import { HttpAdapter, AnyAdapter } from "./adapter";
import { Config } from '../models/config';
import { HttpResponse } from 'vue-resource/types/vue_resource';
import { productAdapter } from './productAdapter';
import { presetAdapter } from './presetAdapter';
import { PresetSet } from '../models/preset';

class ConfigAdaper implements HttpAdapter<Config>, AnyAdapter<Config> {

    public adapt(input: HttpResponse): Config {
        const data = input.data;
        return this.adaptAny(data);
    }

    public adaptAny(input: any): Config {
        const product = productAdapter.adaptAny(input.product);
        const presetSet = this.adaptPresetSet(input.presetSet);
        return new Config(product, presetSet);
    }

    private adaptPresetSet(input: any): PresetSet {
        const inner = presetAdapter.adaptAnyArray(input.inner);
        const complete = presetAdapter.adaptAnyArray(input.complete);
        return {
            inner,
            complete,
        };
    }
}

export const configAdapter = new ConfigAdaper();
